import {createSelector} from 'reselect'
import {NotiStateType} from 'module/Noti/reducer/NotiReducer';
import {selPropGenString} from 'module/Properties/selector/selPropGen'
import {PropID} from 'module/Properties/enum/PropID'

export const selNotiShowButton = createSelector(
	(state: NotiStateType) => state.Noti.allIds.length,
	selPropGenString(PropID.evoApps_notiButtonShowAlways),
	(amount, prop) => Boolean(amount) || prop === 'J',
)

export const selNotiDrawerOpen = (state: NotiStateType) => state.Noti.open;

export const selNotiItems = createSelector(
	(state: NotiStateType) => state.Noti.allIds,
	(state: NotiStateType) => state.Noti.byId,
	(allIds, byId) => allIds.map(id => byId[id]),
);

export const selNotiUnread = createSelector(
	selNotiItems,
	(items) => items.filter(n => n && !n.read),
);

export const selNotiAmountUnread = createSelector(
	selNotiUnread,
	unread => unread.length,
);